import { ApiMutualFundAsset, ApiSegregatedPortfolioAsset } from 'api/rtk-api'
import { useState } from 'react'

import {
  AssetInformationModal,
  Attribute,
  LinkButton,
  MessageBox,
  Numeric,
  Percent,
  Section,
  Space
} from '@/components/core-v2'

import { unpascal } from '../../../util'
import { ReadOnlyPortfolioState } from '../state/portfolio-slice'

const PortfolioDetailsSummaryStateless = ({
  multiplier,
  portfolioId,
  portfolioName,
  portfolioType,
  rebalDef,
  targetWeights,
  taxClassification
}: ReadOnlyPortfolioState) => {
  const [inspectingAsset, setInspectingAsset] = useState<
    ApiMutualFundAsset | ApiSegregatedPortfolioAsset
  >()
  const isModelorFundOfFunds = portfolioType === 'ModelPortfolio' || portfolioType === 'FundOfFunds'

  return (
    <>
      {portfolioId && (
        <Space mx={5} my={6}>
          {isModelorFundOfFunds && <Attribute name="Name">{portfolioName}</Attribute>}

          <Attribute name="Rebalancing">{rebalDef.type}</Attribute>
          {rebalDef.type === 'Frequency' && (
            <Attribute name="Rebalancing Frequency">{unpascal(rebalDef.frequency)}</Attribute>
          )}

          {rebalDef.type === 'Weight' && (
            <Attribute name="Rebalancing Tolerance">
              <Percent fixed numDecimalPlaces={2} value={rebalDef.weightsTolerance * 100} />
            </Attribute>
          )}
          {isModelorFundOfFunds && (
            <div>
              <Attribute name="ID">{portfolioId}</Attribute>
              <Attribute name="Portfolio multiplier">
                <Numeric value={multiplier} />
              </Attribute>
              <Attribute name="Tax classification">{taxClassification}</Attribute>
            </div>
          )}
          <AssetInformationModal
            assetId={inspectingAsset?.assetId}
            isOpen={Boolean(inspectingAsset)}
            onClose={() => setInspectingAsset(undefined)}
          />
          <Section mt={5} type="primary">
            <Section type="secondary">
              <Attribute name="Performance assets">Weight</Attribute>
            </Section>
            {targetWeights?.map(x => (
              <Attribute
                key={x.asset.assetId}
                nameComponent={
                  <LinkButton underline onClick={() => setInspectingAsset(x.asset)}>
                    {x.asset?.name}
                  </LinkButton>
                }
              >
                <Percent fixed numDecimalPlaces={2} value={x.weight * 100} />
              </Attribute>
            ))}
          </Section>
        </Space>
      )}
      {portfolioId === undefined && (
        <Space mx={5} my={6}>
          <MessageBox state="warning" title="A portfolio does not yet exist for this trade">
            Please edit the trade and add a portfolio
          </MessageBox>
        </Space>
      )}
    </>
  )
}

export default PortfolioDetailsSummaryStateless
